import React from 'react';
import styled from 'styled-components';
import { Typography, Colors } from '@inplayer-org/inplayer-ui';

// data
import { colors } from 'data/colors';

// utils
import formatNumber from 'utils/formatNumber';

// types
import { ChartObject } from 'pages/MerchantPages/Analytics/components/PaymentsAnalyticsChart';

// components
import { Container, Wrapper, DataInfo } from 'pages/MerchantPages/Analytics/components/CustomBarTooltip';

interface Props {
  // these are sent by Tooltip component
  active?: boolean;
  payload?: any;
  label?: string;
  dataKey?: string | undefined;
}

const StyledTypography = styled(Typography)`
  font-size: ${({ theme }) => theme.font.sizes.small};
`;

const CustomLineChartTooltip: React.FunctionComponent<Props> = ({ active, payload, label, dataKey = '' }) => {
  const currenciesData: ChartObject = payload && payload[0] ? payload[0].payload : {};

  const currencyView = Object.keys(currenciesData)
    .filter((name) => !['groupBy', 'keyGroup', 'name', 'timestamp'].includes(name))
    .reverse()
    .map((item, index) => {
      return (
        <Wrapper key={item}>
          <DataInfo color={payload[index].color}>
            {item}: {formatNumber(currenciesData[item])}
          </DataInfo>
        </Wrapper>
      );
    });

  return active ? (
    <Container>
      <StyledTypography variant="p">{label}</StyledTypography>
      {currencyView}
    </Container>
  ) : null;
};

export default CustomLineChartTooltip;
